/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: package-advanced-metadata-view-component.ts
 *
 * Created by randysorensen on 11/30/17.
 */

'use strict';

function PackageAdvancedMetadataViewController(
    this: JS5Object, _: JS5Object, $q: JS5Object, ModalService: JS5Object, PackageUtilService: JS5Object,
    PermissionsService: JS5Object, MetadataService: JS5Object) {

    const PACKAGE_ADVANCED_METADATA_VIEW_STATE = 'PACKAGE_ADVANCED_METADATA_VIEW_STATE';


    //======//
    // Data //
    //======//

    const queryForPermissions = (): JS5Promise => {
        return $q.all({
            canRead: PermissionsService.canRead(PACKAGE_ADVANCED_METADATA_VIEW_STATE),
            canWrite: PermissionsService.canWrite(PACKAGE_ADVANCED_METADATA_VIEW_STATE),
        })
            .then((perms: JS5Object) => {
                this.isAdmin = PermissionsService.isAdmin();
                this.canRead = perms.canRead || perms.canWrite;	// write implies read
                this.canWrite = perms.canWrite;
                return perms;
            });
    };

    const composeMetadataComponents = (packageObject: JS5Object) => {
        this.metadataComponentsMap = MetadataService.buildCustomComponentMap(
            packageObject.metadata.properties,
            PackageUtilService.errorsAndWarnings()[packageObject.name]
        );

        this.metadataComponentsMap = _.pickBy(this.metadataComponentsMap, (pkgMetaProp: JS5Object) => {
            return pkgMetaProp.advanced;
        });
    };

    const queryForData = () => {
        if (this.canRead) {
            $q.all({
                metadataProperties: MetadataService.propertiesPromise,
            })
                .then((editData: JS5Object) => {
                    composeMetadataComponents(this.packageObject);

                    this.loadingIndicator.show = false;

                    return editData;
                });
        } else {
            this.loadingIndicator.show = false;
        }
    };

    const packageReverted = (packageObject: JS5Object) => {
        composeMetadataComponents(packageObject);
    };

    const packageSaved = () => {
        PackageUtilService.createErrorsAndWarningsMap(this.packageObject.validationResult);
        composeMetadataComponents(this.packageObject);
    };


    //================//
    // Template Logic //
    //================//

    this.showHierarchicalMetadataModal = () => {
        ModalService.showPkgHierarchicalMetadataModal(this.packageObject)
    };
    this.onExternalIdChange = () => {
        if (_.get(this.packageObject, 'externalId.length') == 0)
            this.packageObject.externalId = null;
    };
    this.clearExternalId = () => {
        this.packageObject.externalId = null;
        this.packageAdvancedMetadataEditorForm.$setDirty();
    };
    this.clearExternalDateUpdated = () => {
        this.packageObject.externalDateUpdated = null;
        this.packageAdvancedMetadataEditorForm.$setDirty();
    };
    // shared Nielsen properties list
    // property name => user-friendly label
    // order determines display order
    this.nielsenFieldLabels = {
        nielsenDsrcId: 'DSRC ID',
        nielsenDsrcName: 'DSRC Name',
        nielsenAssetId: 'Asset ID',
        nielsenAssetName: 'Asset Name',
        nielsenEpisodeId: 'Episode ID',
        nielsenSId: 'SID',
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.showHierarchicalMetadataButton = true;

        this.canRead = false;
        this.canWrite = false;
        this.isAdmin = false;
        this.loadingIndicator.show = true;

        // Set event handlers in PackageUtilService
        PackageUtilService.tabSaveFunction = null;
        PackageUtilService.tabRevertFunction = packageReverted;
        PackageUtilService.postPackageSaveFunction = packageSaved;

        queryForPermissions()
            .then(() => {
                queryForData();
            });
    };

    this.$postLink = () => {
        PackageUtilService.editorForm = this.packageAdvancedMetadataEditorForm;
    };
}


angular
    .module('prism-ui.package')
    .component('packageAdvancedMetadataView', {
        controller: PackageAdvancedMetadataViewController,
        templateUrl: 'package/editor/components/view/advancedMetadata/package-advanced-metadata-view-template.html',
        bindings: {
            packageObject: '=',
            loadingIndicator: '=',
            pkgEditCtrl: '=',	// not ideal - breaks the least stuff until we can refactor
        }
    });
